/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {MouseEventHandler, useContext, useMemo} from "react";
import {AppContext} from "../misc/appContext";
import {AccessKey, AccountStatus} from "../../util/interfaces";
import {BolmateButton} from "../controls";
import {AwesomeIcon} from "@dvrd/dvr-controls";
import classNames from "classnames";
import {useLocation} from "react-router";
import useRight from "../misc/useRight";

interface Props {
    onClickMailSettings: MouseEventHandler;
    onClickApiFlow: MouseEventHandler;
    doesAutoSend: boolean;
}

export default function MailMessage(props: Props) {
    const context = useContext(AppContext);
    const [canSetupAPI] = useRight(AccessKey.API_SETTINGS_SETUP);
    const {doesAutoSend, onClickApiFlow, onClickMailSettings} = props;
    const location = useLocation();
    const shouldHide = useMemo(() => {
        return context.userContext.user?.flex?.hideMailBar === true;
    }, [context.userContext.user]);
    const showMail = useMemo(() => {
        if (location.pathname.endsWith('aanvragen')) return false;
        const {account} = context.accountContext;
        if (!account) return false;
        return ![AccountStatus.ERROR, AccountStatus.SETUP_API].includes(account.status)
    }, [context.accountContext.account, location.pathname]);
    const showAPI = useMemo(() => {
        const {account} = context.accountContext;
        if (!account) return false;
        return [AccountStatus.ERROR, AccountStatus.SETUP_API].includes(account.status);
    }, [context.accountContext.account]);

    if (!showAPI && !showMail) return null;
    if (shouldHide) return null;
    if (doesAutoSend && showMail) return null;
    return (
        <div className={classNames('auto-mail-bar', !showMail && 'center')}>
            {showMail ?
                <label className='auto-mail-label'>Automatisch mailen staat nog uit. Wanneer je er klaar voor
                    bent, zet je dit aan op <span className='link'
                                                  onClick={onClickMailSettings}>de E-mails pagina</span>.</label>
                :
                canSetupAPI ?
                    <BolmateButton onClick={onClickApiFlow} label='Koppelen met Bol'
                                   ornaments={{element: <AwesomeIcon name='link'/>}}/> : null
            }
        </div>
    )
}